// ============================================================
// FILE: src/pages/NotFound.jsx
// ============================================================
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
    return (
        <div className="min-h-[80vh] flex items-center justify-center pt-24">
            <div className="container-custom text-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="max-2xl mx-auto"
                >
                    <h1 className="text-7xl md:text-9xl font-bold gradient-text">404</h1>
                    <h2 className="text-2xl md:text-3xl font-bold mt-4">Page Not Found</h2>
                    <p className="text-gray-400 mt-2">The page you are looking for does not exist.</p>
                    <div className="flex flex-wrap justify-center gap-4 mt-8">
                        <Link to="/" className="btn-primary inline-flex items-center gap-2">
                            <Home size={18} /> Home
                        </Link>
                        <button onClick={() => window.history.back()} className="btn-outline inline-flex items-center gap-2">
                            <ArrowLeft size={18} /> Go Back
                        </button>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default NotFound;